// Action (names)
export const ADD = "ADD";
export const REMOVE = "REMOVE";

// in Actions we return an object {type, payload}

// These Are the action Creator functions
export const addBlogData = (data) => {
  const actionObject = {
    type: ADD,
    payload: data,
  };
  return actionObject;
};

export const removeBlogData = () => {
  const actionObject = {
    type: REMOVE,
  };
  return actionObject;
};
